import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import DatePickerModal from "../../../component/global/DatePicker";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

export default function Education({ data, editedDataHandler, spLoader }) {
    const [eduDate, setEduDate] = useState({
        fa: data.birthday == null ? "" : data.birthday,
        en: "2000-01-01",
    });
    const [eduDatePicker, setEduDatePicker] = useState(false);
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        field_of_study: data.field_of_study == null ? "" : data.field_of_study,
        education: data.education == null ? "" : data.education,
        university: data.university == null ? "" : data.university,
        graduation_date:
            data.graduation_date == null ? "" : data.graduation_date,
        city_education: data.city_education == null ? "" : data.city_education,
    });

    const onChangeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [errors, setErrors] = useState({
        field_of_studyErr: "",
        educationErr: "",
        universityErr: "",
        city_educationErr: "",
    });

    const handleFormErr = () => {
        let field_of_studyErr = "";
        let educationErr = "";
        let universityErr = "";
        let city_educationErr = "";

        if (
            formData.field_of_study === "" ||
            formData.field_of_study === null
        ) {
            field_of_studyErr = t(
                "Src.Pages.UserPages.UserProfile.Education.ield_of_studyErr"
            );
        }
        if (formData.education === "" || formData.education === null) {
            educationErr = t(
                "Src.Pages.UserPages.UserProfile.Education.educationErr"
            );
        }
        if (formData.university === "" || formData.university === null) {
            universityErr = t(
                "Src.Pages.UserPages.UserProfile.Education.universityErr"
            );
        }
        if (
            formData.city_education === "" ||
            formData.city_education === null
        ) {
            city_educationErr = t(
                "Src.Pages.UserPages.UserProfile.Education.city_educationErr"
            );
        }

        setErrors({
            ...errors,
            field_of_studyErr,
            educationErr,
            universityErr,
            city_educationErr,
        });

        if (
            field_of_studyErr === "" &&
            educationErr === "" &&
            universityErr === "" &&
            city_educationErr === ""
        ) {
            return true;
        }

        return false;
    };

    const sendData = (e) => {
        e.preventDefault();

        let noErr = handleFormErr();

        if (!noErr) return false;

        editedDataHandler(e, formData);

        setEduDatePicker(false);
    };

    useEffect(() => {
        setFormData({ ...formData, birthday: eduDate.fa });
    }, [eduDate]);

    return (
        <div className="page-load-fade">
            <form className="general-info-form">
                <Form.Group controlId="major">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.EducationalInfo.Major.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.field_of_study}
                        name="field_of_study"
                        onChange={onChangeHandler}
                        className={errors.field_of_studyErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.field_of_studyErr
                                ? "block"
                                : "none",
                        }}
                    >
                        {errors.field_of_studyErr}
                    </div>
                </Form.Group>

                <Form.Group controlId="formGender">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.EducationalInfo.Degree.Drop.Filter"
                        )}
                    </Form.Label>
                    <div>
                        <select
                            value={formData.education}
                            name="education"
                            id="education"
                            onChange={onChangeHandler}
                            className={
                                "add-user-select" +
                                (errors.educationErr && "input-error")
                            }
                        >
                            <option disabled selected>
                                {t(
                                    "Organizational.CustomerClub.Degree.Disable.Filter"
                                )}
                            </option>
                            <option value={1}>
                                {t(
                                    "UserPanel.Profile.EducationalInfo.Degree.Diploma.Drop.Filter"
                                )}
                            </option>
                            <option value={2}>
                                {t(
                                    "UserPanel.Profile.EducationalInfo.Degree.Bachelor's.Drop.Filter"
                                )}
                            </option>
                            <option value={3}>
                                {t(
                                    "UserPanel.Profile.EducationalInfo.Degree.Master's.Drop.Filter"
                                )}
                            </option>
                            <option value={4}>
                                {t(
                                    "UserPanel.Profile.EducationalInfo.Degree.PhD.Drop.Filter"
                                )}
                            </option>
                        </select>
                    </div>
                    <div
                        className="error"
                        style={{
                            display: errors.sexErr ? "block" : "none",
                        }}
                    >
                        {errors.sexErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="univrsity">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.EducationalInfo.University.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.university}
                        name="university"
                        onChange={onChangeHandler}
                        className={errors.universityErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.universityErr ? "block" : "none",
                        }}
                    >
                        {errors.universityErr}
                    </div>
                </Form.Group>
                <div>
                    <Form.Group controlId="formBasicBday">
                        <Form.Label>
                            {t(
                                "UserPanel.Profile.EducationalInfo.GraduationDate.Place.Holder"
                            )}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={(e) => setEduDate(e.target.value)}
                            value={eduDate.fa}
                            onClick={(e) => setEduDatePicker(true)}
                            readOnly
                        />
                    </Form.Group>
                    <DatePickerModal
                        show={eduDatePicker}
                        close={setEduDatePicker}
                        defaultValue={eduDate.fa}
                        onChange={setEduDate}
                    />
                </div>
                <Form.Group controlId="city">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.EducationalInfo.CityOfStudying.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={data.city_education}
                        name="city_education"
                        onChange={onChangeHandler}
                        className={errors.city_educationErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.city_educationErr
                                ? "block"
                                : "none",
                        }}
                    >
                        {errors.city_educationErr}
                    </div>
                </Form.Group>

                <Form.Group></Form.Group>

                <div className="btn-group">
                    <button onClick={sendData} className=" blue loader-bt">
                        {spLoader ? (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        ) : (
                            <>
                                {t(
                                    "UserPanel.Profile.EducationalInfo.SaveChanges.Button"
                                )}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}
